import { useState } from 'react'
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import ActivityCard from '../../../../Core/Activity/ActivityCard';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
const Tab1 = ({ pageState,setPageState,handleChange,onInputChange,customertypelist, setCustoemrtype, customertype, setCustoemrName,
    customername, setMobile, mobile,
    customergrplist, setcustomerGrp, customergrp,
    terilist, terittory, setTerittory,
    setlead, lead, leadlist,
    setAccount, account, accountlist,
       isGroup,setIsGroup,
    setCurrency,currency,currencylist,
    price,setPrice,pricelist,
    setBankAccount,bankAccount,banklist,
     setMarket, market, marketList,
    industry,setIndustry,industrylist,
    website,setWebsite,
    customerDetails,setCustomerDetails
}) => {
    return (

       <div>
      <div className="px-2 py-3" style={{ background: 'white' }}>
        <div style={{ display: 'flex' }} >
          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                   <Input
                                id="CustomerName"
                                label="Customer Name"
                                style={{ height: "30px" }}
                                 value={pageState.customername}
                    onChange={(e) => handleChange('customername', e.target.value)}
                               
                            />

                </div>
                <div style={{ flex: 1 }}>
                  <SelectSearch
                                list={customertypelist || []}
                                label="Customer Type"
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                placeholder="Customer Type"
                                 value={pageState.customertype}
                      onChange={(val) => handleChange('customertype', val)}
                            />



                </div>
                <div style={{ flex: 1 }}>
                   <Input
                                id="Mobile"
                                label="Mobile"
                                 value={pageState.mobile}
                    onChange={(e) => handleChange('mobile', e.target.value)}
                              
                                style={{ height: "30px" }}
                                 placeholder="Mobile"
                            />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <SelectSearch
                                list={customergrplist}
                                label="Customer Group"
                                 value={pageState.customergrp}
                      onChange={(val) => handleChange('customergrp', val)}
                              
                                getOptionLabel={(item) => item.name}
                                getOptionValue={(item) => item.name}
                                placeholder="Customer Group"
                            />
                </div>


                <div style={{ flex: 1 }}>
                  <SelectSearch
                            list={terilist}
                            label="Territory"
                            getOptionLabel={(item) => item.name}
                            getOptionValue={(item) => item.name}
                            placeholder="Territory"
                              value={pageState.terittory}
                      onChange={(val) => handleChange('terittory', val)}
                        />

                </div>
                <div style={{ flex: 1 }}>
                   <SelectSearch
                            list={leadlist}
                            label="From Lead"
                            
                            getOptionLabel={(item) => item.name}
                            getOptionValue={(item) => item.name}
                            placeholder="From Lead"
                             value={pageState.lead}
                      onChange={(val) => handleChange('lead', val)}
                        />
                </div>
              </div>
 <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <SelectSearch
                            list={accountlist}
                            getOptionLabel={(item) => item.name}
                            getOptionValue={(item) => item.name}
                            placeholder="Account Manager"
                              value={pageState.account}
                      onChange={(val) => handleChange('account', val)}
                        />
                </div>


                <div style={{ flex: 1 }}>
                 

                </div>
                <div style={{ flex: 1 }}>
                  
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Defaults</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>


                <div style={{ flex: 1 }}>
                  <SelectSearch
                                    list={currencylist || []}
                                    label="Billing Currency"
                                   
                                    getOptionLabel={(item) => item.name}
                                    getOptionValue={(item) => item.name}
                                    placeholder="Billing Currency"
                                      value={pageState.currency}
                      onChange={(val) => handleChange('currency', val)}
                                />

                </div>
                <div style={{ flex: 1 }}>
                  <SelectSearch
                                    list={banklist || []}
                                    label="Default Company Bank Account"
                                  
                                    getOptionLabel={(item) => item.name}
                                    getOptionValue={(item) => item.name}
                                    placeholder="Default Company Bank Account"
                                     value={pageState.bankAccount}
                      onChange={(val) => handleChange('bankAccount', val)}
                                />



                </div>
                <div style={{ flex: 1 }}>
                  <SelectSearch
                                    list={pricelist || []}
                                    label="Default Price List"                                  
                                    getOptionLabel={(item) => item.name}
                                    getOptionValue={(item) => item.name}
                                    placeholder="Default Price List"
                                       value={pageState.price}
                      onChange={(val) => handleChange('price', val)}
                                />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>

                <div style={{ flex: 1 }}>

                  <SelectSearch
                            list={industrylist || []}
                            label="Industry Type"
                           
                            getOptionLabel={(item) => item.name}
                            getOptionValue={(item) => item.name}
                            placeholder="Industry Type"
                             value={pageState.industry}
                      onChange={(val) => handleChange('industry', val)}
                        />
                  

                </div>
<div style={{ flex: 1 }}>
                   <SelectSearch
                            list={marketList || []}
                            label="Market Segment"
                           
                            getOptionLabel={(item) => item.name}
                            getOptionValue={(item) => item.name}
                            placeholder="Market Segment"
                             value={pageState.market}
                      onChange={(val) => handleChange('market', val)}
                        />
                </div>
<div style={{ flex: 1 }}>
                  <Input
                            id="CustomerName"
                            label="Website"
                            style={{ height: "30px" }}
                             value={pageState.website}
                    onChange={(e) => handleChange('website', e.target.value)}
                          
                        />
                </div>

              </div>

              <div style={{ display: 'flex', gap: '15px' }}>
               <div style={{ flex: 1 }}>
  <label style={{ height: '19px' }}></label>
  <Checkbox
    id="IsInternalCustomer"
    label="Is Internal Customer"
    value={pageState.isGroup || false}   // ✅ use value instead of checked
    onChange={(checked) => onInputChange("isGroup", checked)}
  />
 

</div>

                
                <div style={{ flex: 1 }}>
                    <Textarea
                        label={"Customer Details"}
                         value={pageState.customerDetails}
                    onChange={(e) => handleChange('customerDetails', e.target.value)}
                       
                      
                    />
                    <p
                    style={{
                      paddingLeft: "4px",
                      paddingRight: "14px",
                      fontWeight: 400,
                      fontSize: "9px",
                      letterSpacing: "0",
                      color: "#2C2B31",
                      lineHeight: '2',
                      fontFamily: "Roboto, sans-serif",
                      marginTop: '0px'
                    }}
                  >
                    Additional information regarding the customer.
                  </p>

                </div>
                 <div style={{ flex: 1 }}>
                 
                </div>
              </div>

            </div>
          </div>
        </div>
           <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
             <ActivityCard doctype="Customer" docname={pageState.customername} />
            </div>
          </div>
        </div>
      </div>

    </div>
    )
}

export default Tab1